import React from "react";
import { Mountain } from "lucide-react";
import FeedbackDialog from "@/components/FeedbackDialog";

export default function Footer() {
  return (
    <footer className="border-t border-[#E5E0D8] mt-24 py-10 bg-[#F0EBE1]" data-testid="main-footer">
      <div className="max-w-7xl mx-auto px-6 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4">
        <div className="flex items-center gap-2">
          <Mountain className="w-5 h-5" style={{ color: "var(--mp-terracotta)" }} />
          <span className="font-serif-display text-xl">MemoryPeaks</span>
        </div>
        <p className="text-sm text-[#5C5C5C]">
          A scrapbook for memories that aren't yours to keep — but to share.
        </p>
        <div className="flex flex-col sm:items-end gap-1">
          <FeedbackDialog />
          <p className="text-xs text-[#8A8A8A]">© {new Date().getFullYear()} MemoryPeaks</p>
        </div>
      </div>
    </footer>
  );
}
